module.exports = __webpack_public_path__ + "static/media/image_14.948d9c4e.png";